// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCautionIcon24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_18400_287740)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M20.2976 15.9318L14.0895 5.53555C13.6424 4.78986 12.8686 4.34766 12.0001 4.34766C11.1403 4.34766 10.3578 4.78986 9.91072 5.53555L3.70267 15.9318C3.24695 16.7035 3.22975 17.6226 3.66827 18.4116C4.10679 19.2006 4.89785 19.6602 5.79208 19.6602H18.2082C19.1024 19.6602 19.8935 19.192 20.332 18.4116C20.7705 17.6312 20.7533 16.7035 20.2976 15.9404V15.9318ZM19.2056 17.77C18.9992 18.1341 18.6295 18.3596 18.2082 18.3596H5.79208C5.37076 18.3596 5.00103 18.1428 4.79467 17.77C4.5883 17.4058 4.5969 16.9636 4.81186 16.6081L11.0199 6.21186C11.2263 5.86503 11.596 5.64827 12.0001 5.64827C12.4043 5.64827 12.774 5.85636 12.9803 6.21186L19.1884 16.5994C19.4034 16.9636 19.412 17.3971 19.2056 17.7613V17.77Z"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M12 11.2412C11.5271 11.2412 11.1401 11.6314 11.1401 12.1083V16.4437C11.1401 16.9205 11.5271 17.3107 12 17.3107C12.4729 17.3107 12.8598 16.9205 12.8598 16.4437V12.1083C12.8598 11.6314 12.4729 11.2412 12 11.2412Z"
					/>
					<path d="M12 10.3738C12.4749 10.3738 12.8598 9.98559 12.8598 9.50672C12.8598 9.02785 12.4749 8.63965 12 8.63965C11.5251 8.63965 11.1401 9.02785 11.1401 9.50672C11.1401 9.98559 11.5251 10.3738 12 10.3738Z" />
				</g>
				<defs>
					<clipPath id="clip0_18400_287740">
						<rect width={17.3} height={15.3038} transform="translate(3.3501 4.34766)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgCautionIcon24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCautionIcon24;
